// src/App.js
import React, { useEffect, useState } from "react";
import "./App.css";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';


const App = () => {  
  return (
    <Routes />
  );
};

export default App;
